import { Component, OnInit } from '@angular/core';
import { ThemeService } from '../../core/services/theme.service';
import { ActivatedRoute } from '@angular/router';
import { EventTheme } from '../../core/models/event-theme';
import { ExtraService } from '../../core/services/extra.service';
import { Constants } from '../../core/config/Constants';

@Component({
	selector: 'app-theme',
	templateUrl: './theme.component.html',
	styleUrls: ['./theme.component.css'],
	providers: [ThemeService]
})
export class ThemeComponent implements OnInit {
	buttonMessage = Constants.SUBMIT_BUTTON_MESSAGE;
	themes: string = 'THEME0001';
	pageTitle: string = "Event Theme";
	isError: boolean = false;
	errorMessage: string;
	message: string = '';
	eventID: string;
	themeArray: Array<any> = new Array();
	eventsTheme = new EventTheme();

	constructor(private extraService: ExtraService, private eventsThemeService: ThemeService, private route: ActivatedRoute) {
		this.extraService.changeStateofSideBarButton(true);
		this.extraService.changeSideBar(true);
		this.themeArray = [
			{ primaryValue: '#009688', secondaryValue: '#FFD31C', themeValue: 'THEME0001' },
			{ primaryValue: '#009688', secondaryValue: '#866768', themeValue: 'THEME0002' },
			{ primaryValue: '#009688', secondaryValue: '#6B82A8', themeValue: 'THEME0003' },
			{ primaryValue: '#009688', secondaryValue: '#D73A31', themeValue: 'THEME0004' },

			{ primaryValue: '#00468C', secondaryValue: '#DEB31A', themeValue: 'THEME0005' },
			{ primaryValue: '#00468C', secondaryValue: '#FDAE84', themeValue: 'THEME0006' },
			{ primaryValue: '#00468C', secondaryValue: '#BAF7BF', themeValue: 'THEME0007' },
			{ primaryValue: '#00468C', secondaryValue: '#B2B2A2', themeValue: 'THEME0008' },

			{ primaryValue: '#C5050C', secondaryValue: '#687CB2', themeValue: 'THEME0009' },
			{ primaryValue: '#C5050C', secondaryValue: '#FFCC00', themeValue: 'THEME0010' },
			{ primaryValue: '#C5050C', secondaryValue: '#BAF7BF', themeValue: 'THEME0011' },
			{ primaryValue: '#C5050C', secondaryValue: '#9AABB9', themeValue: 'THEME0012' },

			{ primaryValue: '#CFD58B', secondaryValue: '#F99797', themeValue: 'THEME0013' },
			{ primaryValue: '#CFD58B', secondaryValue: '#765285', themeValue: 'THEME0014' },
			{ primaryValue: '#CFD58B', secondaryValue: '#A8D0E6', themeValue: 'THEME0015' },
			{ primaryValue: '#CFD58B', secondaryValue: '#F4C20D', themeValue: 'THEME0016' },

			{ primaryValue: '#765285', secondaryValue: '#E9CC66', themeValue: 'THEME0017' },
			{ primaryValue: '#765285', secondaryValue: '#F99797', themeValue: 'THEME0018' },
			{ primaryValue: '#765285', secondaryValue: '#A0C1B8', themeValue: 'THEME0019' },
			{ primaryValue: '#765285', secondaryValue: '#BAF7BF', themeValue: 'THEME0020' },

			{ primaryValue: '#02A4D3', secondaryValue: '#E25F70', themeValue: 'THEME0021' },
			{ primaryValue: '#02A4D3', secondaryValue: '#E9C77B', themeValue: 'THEME0022' },
			{ primaryValue: '#02A4D3', secondaryValue: '#9AABB9', themeValue: 'THEME0023' },
			{ primaryValue: '#02A4D3', secondaryValue: '#E2B49A', themeValue: 'THEME0024' },

			{ primaryValue: '#E77200', secondaryValue: '#C4D6A4', themeValue: 'THEME0025' },
			{ primaryValue: '#E77200', secondaryValue: '#B8DDE1', themeValue: 'THEME0026' },
			{ primaryValue: '#E77200', secondaryValue: '#7A6855', themeValue: 'THEME0027' },
			{ primaryValue: '#E77200', secondaryValue: '#FDD26E', themeValue: 'THEME0028' },

			{ primaryValue: '#032B2F', secondaryValue: '#FDD26E', themeValue: 'THEME0029' },
			{ primaryValue: '#032B2F', secondaryValue: '#56B1BF', themeValue: 'THEME0030' },
			{ primaryValue: '#032B2F', secondaryValue: '#D73A31', themeValue: 'THEME0031' },
			{ primaryValue: '#032B2F', secondaryValue: '#FDAE84', themeValue: 'THEME0032' },

			{ primaryValue: '#607D8B', secondaryValue: '#DEB31A', themeValue: 'THEME0033' },
			{ primaryValue: '#607D8B', secondaryValue: '#FDAE84', themeValue: 'THEME0034' },
			{ primaryValue: '#607D8B', secondaryValue: '#E25F70', themeValue: 'THEME0035' },
			{ primaryValue: '#607D8B', secondaryValue: '#B2B2A2', themeValue: 'THEME0036' },

			{ primaryValue: '#60412b', secondaryValue: '#F99797', themeValue: 'THEME0037' },
			{ primaryValue: '#60412b', secondaryValue: '#FFCC00', themeValue: 'THEME0038' },
			{ primaryValue: '#60412b', secondaryValue: '#BAF7BF', themeValue: 'THEME0039' },
			{ primaryValue: '#60412b', secondaryValue: '#9AABB9', themeValue: 'THEME0040' }

		];
	}

	ngOnInit() {
		this.route.params.subscribe(params => {
			this.getResponse(params['eventId']);
			// let id = params['eventId']; 
		});
	}

	getResponse(eventId) {
		this.eventID = eventId;

		this.extraService.setCurrentEventId(eventId);
		this.extraService.changeStateofSideBarButton(true);
		this.extraService.changeSideBar(true);

		this.extraService.setCurrentEventId(eventId);
		if (eventId) {
			this.setEventTheme(eventId);
		}
	}

	setEventTheme(eventId) {
		this.eventsThemeService.getEventTheme(eventId).subscribe(event => {
			if (event) {
				this.themes = this.eventsTheme.theme_id = event.theme_id;
				//console.log(this.themes)
			} else {
			}
		});
	}

	submit() {
		this.isError = true;
		if (this.validate()) {
			this.eventsThemeService.updateEventTheme(this.eventsTheme, this.eventID).then(res => {
				this.message = 'Theme Selected Successfully';
			}).catch(error => {
				this.message = error.message;
			});
			this.isError = false;
		} else {
			this.isError = true;
			this.errorMessage = 'Something Went Wrong';
		}
		setTimeout(function () {
			this.message = null;
		}.bind(this), 2000);

		this.setEventTheme(this.eventID);

	}

	validate() {
		if (this.themes) {
			this.eventsTheme.theme_id = this.themes;
			return true;
		} else {
			return false;
		}
	}
}


// WEBPACK FOOTER //
// /app/src/app/event/theme/theme.component.ts